<template>
  <a-drawer
    :width="width"
    :visible="visible"
    @ok="handleOk"
    :headerStyle="{paddingTop:'0px'}"
    :bodyStyle="{padding: 0 }"
    @close="handleCancel"
   >
    <div class="model-top">
      信息重复
    </div>
   <div style="padding-bottom: 40px">
     <div class="top-tips">
       <img src="@/assets/driver/err-tips.png">
       车牌号被以下信息占用
     </div>

     <div class="ass-share">
       <div class="ass-share-left">
         <div class="ass-share-left-item">
           <span class="label">车牌号</span>
           <span class="val">{{model.licensePlateNumber}}</span>
         </div>
         <div class="ass-share-left-item">
           <span class="label">品牌车系</span>
           <span class="val" v-if="model.brandName">{{model.brandName}} {{model.modelName}}</span>
           <span class="val" v-else>-</span>
         </div>
         <div class="ass-share-left-item">
           <a-button type="primary" @click="beShare()">{{driverId?'绑定':'前往查看'}}</a-button>
         </div>
       </div>

     </div>
   </div>
  </a-drawer>
</template>

<script>

  import { httpAction } from '@/api/manage'
  export default {
    name: 'RepeatCarList',
    components: {

    },
    data () {
      return {
        title:'注意',
        width:530,
        visible: false,
        disableSubmit: false,
        model:{},
        driverId:''
      }
    },
    methods: {
      edit (car,driverId) {
        this.visible=true
        this.model= car;
        this.driverId = driverId;
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.close();
      },
      submitCallback(data){
        this.$emit('ok',data);
        this.visible = false;
      },
      handleCancel () {
        this.close()
      },beShare(){
        let that = this;
        if(this.driverId){
          let formData = {
            "carId": this.model.id,
            driverId:this.driverId
          }
          httpAction("/dm/dmDriver/bdCar",formData,"POST").then((res)=>{
            if(res.success){
              that.$message.success("操作成功!");

              //that.$emit("ok", this.model.id);
              that.$emit("close");
              that.visible = false
            }else{
              that.$message.warning(res.message);
              that.$emit("close");
              that.visible = false
            }
          })
        }else{
          that.visible = false
          that.$emit("ok", this.model.id);
        }

      }
    }
  }
</script>
<style scoped>
  .model-top{
    height: 92px;
    line-height: 92px;
    color: #0A1629;
    font-size: 22px;
    border-bottom: 1px solid rgba(230, 237, 245, 1);
    padding-left: 24px;
  }
  .top-tips{
    height: 72px;
    line-height: 72px;
    color: rgba(246, 81, 96, 1);
    padding-left: 24px;
  }
  .top-tips img{
    width: 20px;
    height: 20px;
    vertical-align:sub;
  }
  .j-table-force-nowrap{
    padding: 20px 40px 0 40px;
  }
  .ass-share{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 12px 24px;
    height: 98px;
    background: rgb(232, 241, 255);
    border-radius: 12px;

  }
  .ass-share .ass-share-left{
    flex: 1;
    display:flex;
    align-items: center;
  }
  .ass-share .ass-share-left .ass-share-left-item{
    flex:1;
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
  }
  .ass-share-left-item .label{
    color: rgba(145, 146, 158, 1);
  }
  .ass-share-left-item .val{
    color:rgba(10, 22, 41, 1);
    font-size: 16px;
    text-align: center;
  }
  .zxdbs{
    color: rgb(63, 140, 255);
    margin-left: 26px;
    cursor: pointer;
  }
</style>